// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9d20c140","92":"fe94ef2b","104":"31342012","239":"ad40150f","455":"b91e6987","488":"e55605dd","872":"4be7b692","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};